<template>
    <div class="w-6 h-6">
        <base-dropdown
            placement="bottom-end"
            class="w-full h-full"
        >
            <button
                slot="trigger"
                slot-scope="{ is_open, toggle }"
                :class="{ 'shadow-outline': is_open }"
                class="w-full h-full btn btn-none"
                type="button"
                @click.prevent="toggle"
            >
                <base-svg
                    name="icon-dots-horizontal"
                    class="w-full h-full"
                />
            </button>

            <div
                slot="menu"
                class="w-64 dropdown-menu"
            >
                <router-link
                    :to="{
                        name: $router.fix('dashboard.*.maintenances.edit'),
                        params: {
                            maintenance: maintenance.uuid
                        }
                    }"
                    class="dropdown-menu-link"
                >
                    Edit
                </router-link>
            </div>
        </base-dropdown>
    </div>
</template>

<script>
    export default {
        props: {
            maintenance: {
                type: Object,
                required: true
            }
        }
    }
</script>
